import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { BookingWidget } from '../components/BookingWidget';

export function Book() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Booking Section with TidyCal Widget */}
      <section className="py-16 md:py-24 bg-bg-gray-light">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-text-dark mb-4">
            Schedule a Project Call
          </h2>
          <p className="text-center text-lg text-text-gray mb-4">
            Book a free 15-minute call to discuss your project needs
          </p>
          <p className="text-center text-text-gray mb-12">
            or email us directly at{' '}
            <a
              href="mailto:till@pairing.dev?subject=Pairing%20Project%20Inquiry%20%2F%20Projektanfrage"
              className="text-primary-blue hover:underline font-medium"
            >
              till@pairing.dev
            </a>
          </p>
          <div className="bg-white rounded-lg shadow-lg p-6">
            <BookingWidget />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
